import httpApi from '@/apis/httpApi';

const config = {
  appkey: httpApi.live.appkey,
  Host: 'console.easemob.com',
  https: true,
  isHttpDNS: true,
  isMultiLoginSessions: true,
  isWindowSDK: false,
  isSandBox: false,
  isDebug: true,
  isStropheLog: false,
  autoReconnectNumMax: 5,
  autoReconnectInterval: 2,
  isWebRTC: true,
  i18n: 'us',
  isAutoLogin: true,
  p2pMessageCacheSize: 500,
  delivery: true,
  groupMessageCacheSize: 200,
  loglevel: 'ERROR',
  enableLocalStorage: true,
  isFixedDeviceId: false
};

export default config;
